import { BASE_BACKEND_URL, getAccessToken } from '../../auth'
import { authJson, buildQuery, handleResponse } from './shared/authJson'

export async function fetchRbacUsers(params = {}) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users${buildQuery(params)}`)
}

export async function fetchRbacUser(userId) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/${userId}`)
}

export async function createRbacUser(payload) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users`, {
    method: 'POST',
    body: JSON.stringify(payload)
  })
}

export async function updateRbacUser(userId, payload) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/${userId}`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  })
}

export async function updateRbacUserStatus(userId, payload) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/${userId}/status`, {
    method: 'PUT',
    body: JSON.stringify(payload)
  })
}

export async function resendRbacUserInvitation(userId) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/${userId}/resend_invitation`, {
    method: 'POST'
  })
}

export async function fetchRbacUserHistory(userId, params = {}) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/${userId}/history${buildQuery(params)}`)
}

export async function validateActivationToken(token) {
  const response = await fetch(`${BASE_BACKEND_URL}/rbac/activation${buildQuery({ token })}`, {
    headers: {
      Accept: 'application/json'
    }
  })
  return handleResponse(response)
}

export async function activateRbacAccount(payload) {
  const response = await fetch(`${BASE_BACKEND_URL}/rbac/activation`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
  return handleResponse(response)
}

export async function fetchUserRoles(userId) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/${userId}/roles`)
}

export async function assignUserRoles(userId, roleIds) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/${userId}/roles`, {
    method: 'PUT',
    body: JSON.stringify({ role_ids: roleIds })
  })
}

export async function bulkAssignUserRoles(assignments) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/roles/bulk`, {
    method: 'PUT',
    body: JSON.stringify({ assignments })
  })
}

export async function revokeUserSessions(userId) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/${userId}/sessions`, {
    method: 'DELETE'
  })
}

export async function updateCanManageRbac(userId, canManageRbac) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/${userId}/can_manage_rbac`, {
    method: 'PUT',
    body: JSON.stringify({ can_manage_rbac: !!canManageRbac })
  })
}

export async function fetchCurrentUser() {
  return authJson(`${BASE_BACKEND_URL}/users/current`)
}

export { getAccessToken }

export async function fetchRbacAssignedData(userId) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/${userId}/assigned_data`)
}

export async function fetchRbacAssignmentOptions(params = {}) {
  const { qualifiers = {}, ...other } = params
  if (other.qualifier) {
    return authJson(`${BASE_BACKEND_URL}/rbac/users/assignment_options`, {
      method: 'POST',
      body: JSON.stringify({ ...other, qualifiers })
    })
  }
  const query = new URLSearchParams(buildQuery(other).replace(/^\?/, ''))
  Object.entries(qualifiers).forEach(([key, values]) => {
    values.forEach((value) => query.append(`qualifiers[${key}][]`, value))
  })
  return authJson(`${BASE_BACKEND_URL}/rbac/users/assignment_options?${query}`)
}

export async function fetchRbacValidAssignmentQualifiers(resource, qualifiers) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/valid_assignment_qualifiers`, {
    method: 'POST',
    body: JSON.stringify({ resource, qualifiers })
  })
}

export async function fetchRbacQualifierOptions(resource, qualifiers) {
  return authJson(`${BASE_BACKEND_URL}/rbac/users/assignment_qualifier_options`, {
    method: 'POST',
    body: JSON.stringify({ resource, qualifiers, per_page: 10 })
  })
}
